import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiService } from '../../constants/ApiService';

const BlogList = () => {

  const navigate = useNavigate();
  const [blogTable, setBlogTable] = useState([]);
  const getBlogData = async (page = 1, limit = 10, search = "") => {
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          'accept': 'application/json'
        }
      };

      const response = await apiService.get(`/api/BlogMaster/allblog?pageNo=${page}&limit=${limit}&searchKey=${search}`, config)
      if (response.response && response.response.data.errors) {
        console.log(response.response?.data?.errors)
      }

      if (response.status === true) {
        console.log(response.blogMasterData)
        setBlogTable(response.blogMasterData)
        // console.log(response.message);
      }
      else {
        console.log(response.message);
      }
    } catch (error) {
      console.log(error)
      alert('SomeThing went wrong!!');
    }
  };

  useEffect(() => {
    getBlogData();
  }, [!blogTable]);

  const goBlogDetail = (blogId) => {
    navigate('/blogdetail', { state: { blogId: blogId } });
  }

  return (
    <>
      {/* Breadcrumb Section Start */}
      <section className="breadscrumb-section pt-0">
        <div className="container-fluid-lg">
          <div className="row">
            <div className="col-12">
              <div className="breadscrumb-contain">
                <h2>Blog Page</h2>
                <nav>
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <a href="index-2.html">
                        <i className="fa-solid fa-house" />
                      </a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Blog
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Breadcrumb Section End */}
      <section className="blog-section section-b-space">
        <div className="container-fluid-lg">
         
              <div className="row g-4">
            
                {blogTable? blogTable.map((data, index) => (
                  <>
                    <div className="col-sm-12">

                      <div
                        className="blog-box blog-list wow fadeInUp"
                        style={{ visibility: "visible", animationName: "fadeInUp" }}
                      >
                        <div className="blog-image">
                          <img
                            src={process.env.REACT_APP_API_BASE_URL +data.img_url}
                            className=" lazyloaded"
                            alt=""
                          />
                        </div>

                        <div className="blog-contain blog-contain-2">
                          <div className="blog-label">
                            <span className="time">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="feather feather-clock"
                              >
                                <circle cx={12} cy={12} r={10} />
                                <polyline points="12 6 12 12 16 14" />
                              </svg>{" "}
                              <span>{data.updated_on.split('T')[0]}</span>
                            </span>
                            <span className="super">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="feather feather-user"
                              >
                                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                                <circle cx={12} cy={7} r={4} />
                              </svg>{" "}
                              <span>{data.username}</span>
                            </span>
                          </div>
                          <a href="blog-detail.html">
                            <h3>{data.blog_title}</h3>
                          </a>
                          <p>
                            {data.blog_content}
                          </p>
                          <button
                            type="button"
                            onClick={() => { goBlogDetail(data.id) }}
                            className="blog-button"
                          >
                            Read More <i className="fa-solid fa-right-long" />
                          </button>
                        </div>
                      </div>
                    </div>
                  </>
                )):
                <>
                <div className="col-12"><h2>No blogs to show for now</h2></div>
                </>}
                
          </div>
          </div>
      </section>

    </>
  )
}

export default BlogList;